import {FormEvent, useState} from "react";
import {Alert, Card, Form} from "react-bootstrap";
import {Link} from "react-router";
import {UsersApi} from "../api/UsersApi";
import {ErrorAlert} from "../components/ErrorAlert";
import {SubmitButton} from "../components/SubmitButton";
import {usePageTitle} from "../components/usePageTitle";
import {auth} from "../i18n";
import {useTurnstile} from "../components/useTurnstile";

// Each request passes Cloudflare Turnstile's bot check first.
export function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [busy, setBusy] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState<unknown>();
    const turnstile = useTurnstile();
    usePageTitle(auth.forgotPassword.title);

    const submit = async (e: FormEvent) => {
        e.preventDefault();
        setBusy(true);
        setError(undefined);
        try {
            const turnstileToken = await turnstile.waitForToken();
            if (!turnstileToken) {
                return;
            }
            await UsersApi.forgotPassword(email.trim(), turnstileToken);
            setSent(true);
        } catch (err) {
            setError(err);
            turnstile.reset();
        } finally {
            setBusy(false);
        }
    };

    return (
        <Card className="auth-card mx-auto mt-md-4">
            <Card.Body className="p-4">
                <h1 className="h4 mb-3">{auth.forgotPassword.title}</h1>
                {sent ? (
                    // The API answers the same whether or not the address has an account.
                    <Alert variant="success">{auth.forgotPassword.sent}</Alert>
                ) : (
                    <>
                        <p className="text-body-secondary">{auth.forgotPassword.intro}</p>
                        <ErrorAlert error={error} messages={{ 429: auth.forgotPassword.tooMany }}/>
                        <Form onSubmit={submit}>
                            <Form.Group className="mb-3" controlId="email">
                                <Form.Label>{auth.forgotPassword.email}</Form.Label>
                                <Form.Control type="email" autoComplete="email" autoFocus required value={email} onChange={e => setEmail(e.target.value)}/>
                            </Form.Group>
                            <div className="mb-3">
                                {turnstile.widget}
                                {turnstile.failed && <Alert variant="warning">{auth.forgotPassword.turnstileUnavailable}</Alert>}
                            </div>
                            <SubmitButton busy={busy} className="w-100">{auth.forgotPassword.submit}</SubmitButton>
                        </Form>
                    </>
                )}
                <div className="text-center mt-3">
                    <Link to="/login" className="small">{auth.forgotPassword.backToSignIn}</Link>
                </div>
            </Card.Body>
        </Card>
    );
}
